import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "title-tooltip",
  templateUrl: "./title-tooltip.component.html",
  styleUrls: ["./title-tooltip.component.scss"],
})
export class TitleTooltipComponent implements OnInit {
  @Input() definition;
  @Input() title;
  @Input() hidePrefix;

  constructor() {}

  ngOnInit() {}

  decapitalize(desc) {
    if (desc) {
      return desc.charAt(0).toLowerCase() + desc.slice(1);
    } else {
      return "";
    }
  }
}
